import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_WorkspaceSchedulationOldSchedulationsTable = _resolveComponent("WorkspaceSchedulationOldSchedulationsTable")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.workspaceSchedulationOldSchedulationsDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('workspace.schedulation.executedSchedulations')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.closeDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_WorkspaceSchedulationOldSchedulationsTable, { propSchedulations: _ctx.schedulations }, null, 8, ["propSchedulations"])
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
}